import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "el-upload__text" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = { class: "d-flex align-items-center mb-3" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_8 = { class: "mb-5" }

import { ref } from "vue";
import { useStore } from "@/store";
import type { UploadUserFile } from "element-plus";
import { UploadFilled } from "@element-plus/icons-vue";
import { Delete } from "@element-plus/icons-vue";
import ItServices from "../../services/ItServices";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadPublicFileModal',
  setup(__props) {

const isLoading = ref(false);
const fileList = ref<UploadUserFile[]>([]);
const store = useStore();
const user = store.state.AuthModule.user;
const uploadedLinks = ref<string[]>([]);
const operatorInfo = ref<any>({
  name: user.nativeName,
  email: user.email,
  updatedAt: new Date().toISOString(),
});

const submitUpload = async () => {
  isLoading.value = true;
  try {
    const formData = new FormData();
    fileList.value.forEach((file) => {
      formData.append("files[]", file.raw);
      formData.append("fileNames[]", file.name);
    });
    formData.append("operatorInfo", JSON.stringify(operatorInfo.value));
    const res = await ItServices.uploadPublicFiles(formData);
    if (res) {
      notification.success();
      fileList.value = [];
      uploadedLinks.value = res;
    }
  } catch (e) {
    notification.danger();
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const handleRemove = (file: UploadUserFile) => {
  fileList.value = fileList.value.filter((f) => f !== file);
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_upload, {
      "file-list": fileList.value,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      "auto-upload": false,
      disabled: isLoading.value,
      class: "w-350px",
      "show-file-list": false,
      multiple: "",
      drag: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
            default: _withCtx(() => [
              _createVNode(_unref(UploadFilled))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              innerHTML: _ctx.$t('fields.dropFileHereOrClickHere')
            }, null, 8, _hoisted_2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["file-list", "disabled"]),
    (fileList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("fields.previewLinks")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_input, {
                  modelValue: file.name,
                  "onUpdate:modelValue": ($event: any) => ((file.name) = $event),
                  disabled: isLoading.value,
                  style: {"max-width":"1100px"}
                }, {
                  prepend: _withCtx(() => [
                    _createTextVNode("https://bcrpropublic.s3.ap-southeast-1.amazonaws.com/")
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (handleRemove(file)),
                  disabled: isLoading.value,
                  class: "ms-4",
                  icon: _unref(Delete),
                  circle: "",
                  type: "danger",
                  size: "small"
                }, null, 8, ["onClick", "disabled", "icon"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_button, {
        onClick: submitUpload,
        loading: isLoading.value,
        disabled: fileList.value.length <= 0,
        type: "success",
        plain: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.clickToUpload")), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    (uploadedLinks.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("fields.uploadedFileLinks")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLinks.value, (link, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_el_link, {
                href: link,
                target: "_blank",
                type: "primary",
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link), 1)
                ]),
                _: 2
              }, 1032, ["href"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})